import { render, staticRenderFns } from "./block-header-bar.vue?vue&type=template&id=7b40ad25&scoped=true&"
import script from "./block-header-bar.vue?vue&type=script&lang=js&"
export * from "./block-header-bar.vue?vue&type=script&lang=js&"
import style0 from "./block-header-bar.vue?vue&type=style&index=0&id=7b40ad25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b40ad25",
  null
  
)

export default component.exports